{
  "de": {
    "dataProtection": {
      "copyright": "Beachte die Urheberrechte, wenn du fremde Inhalte verwendest",
      "data": "Teile niemals sensible oder persönliche Informationen mit einer KI-Anwendung",
      "deletionPolicy": {
        "content": "Aufgrund von Datenschutzvorgaben werden alle Inhalte von Schüler*innen nach 365 Tagen gelöscht."
      },
      "pupils": "Verwende keine Inhalte mit persönlichen Daten von dir oder anderen Personen",
      "students": "Verwende keine Inhalte mit persönlichen Daten deiner Schüler*innen",
      "worksheets": "Keine Sorge: Deine Arbeitsblätter bleiben erhalten."
    }
  }
}
